import React from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Flex, TextBox } from '../styles/globalStyles';

const SnsIcon = ({ img, matchese, title, onClick }) => {
  return (
    <Flex cursor='pointer' justifyContentjustifyContent={'center'} flexDirection={'column'}>
      <LazyLoadImage
        onClick={onClick}
        src={img}
        alt='snsIcon'
        style={{
          width: matchese ? '72px' : '89px',
          height: matchese ? '72px' : '89px',
          borderRadius: '50%',
          boxShadow: '1px 2px 5px -1px rgb(0 0 0 / 20%)',
          marginBottom: '3px',
        }}
      />
      <TextBox fontSize='13px' justifyContent='center'>
        {title}
      </TextBox>
    </Flex>
  );
};

export default SnsIcon;
